import React from 'react';
import AssetItem from './AssetItem';

const MovieItem = props => <AssetItem type="movie" {...props} />;

export default MovieItem;
